var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IconWrapper relative"},[_c('icon',{staticClass:"IconWrapper__icon",style:({
            left: _vm.direction === 'left' ? `${_vm.offset}px` : 'auto',
            right: _vm.direction === 'right' ? `${_vm.offset}px` : 'auto',
        }),attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }